var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.6928,
    y1: 256.0002,
    x2: 480.3072,
    y2: 256.0002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M445.1,295.3h-4.8v-52.1c0-4.4-3.6-8-8-8h-44.9v-58.5c0-4.4-3.6-8-8-8h-40.7l40-40c3.1-3.1,3.1-8.2,0-11.3 L276.1,14.8c-1.5-1.5-3.5-2.3-5.7-2.3h0c-2.1,0-4.2,0.9-5.7,2.4L111.7,168.7H71.7c-22.1,0-40.1,18-40.1,40.1v1.6v258 c0,17.2,14,31.2,31.2,31.2h369.3c4.4,0,8-3.6,8-8v-68.1h11.2c15.6,0,28.8-13.2,28.8-28.8v-62.5v-0.8v-0.8 C480.3,310.7,464.8,295.3,445.1,295.3z M270.4,31.8l91.2,91.2L316,168.7h-25.4l23.2-23.2c1.5-1.5,2.3-3.5,2.3-5.7 c0-2.1-0.8-4.2-2.3-5.7c-3.1-3.1-4.9-7.2-4.9-11.6c0-4.3,1.7-8.4,4.9-11.6c1.5-1.5,2.3-3.5,2.3-5.7s-0.8-4.2-2.3-5.7l-20-20 c-3.1-3.1-8.2-3.1-11.3,0c-6.5,6.5-16.6,6.5-23.1,0c-3.1-3.1-8.2-3.1-11.3,0l-87.8,87.9l-0.9,1.1h-24.9L270.4,31.8z M297.4,139.2 l-29.5,29.5h-86.3L254.3,96c10.2,6.2,22.9,6.2,33.1,0l10.1,10.1c-3,5-4.6,10.6-4.6,16.5C292.8,128.5,294.4,134.2,297.4,139.2z  M47.7,208.7c0-13.3,10.8-24,24-24h299.6v50.5H71.7c-13.5,0-24-10.9-24-24.8V208.7z M424.2,483.5H62.9c-8.4,0-15.2-6.8-15.2-15.2 V242.8c6.7,5.2,15,8.4,24,8.4h307.6h44.9v52.1v48.1h-36.8c-19.5,0-36,16.5-36,36c0,9.2,3.3,17.4,10.4,25.7 c6.6,6.6,15.9,10.4,25.7,10.4h36.8V483.5z M451.5,407.4h-64.1c-5.4,0-10.8-2.1-13.9-5.2c-4.1-4.8-6.1-9.5-6.1-14.8 c0-10.9,9.2-20,20-20h44.9h12h0.8c7.2,0,13.7-2.1,19.2-5.6v32.8C464.3,401.4,458.3,407.4,451.5,407.4z M464.3,332.1 c0,10.8-8.4,19.2-19.2,19.2h-0.8h-4v-40.1h4.8c10.8,0,19.2,8.4,19.2,19.2v0.8V332.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.b4cb9d0844ad1619f3277dd5e70b34e0.svg";
export { ForwardRef as ReactComponent };